import { render, staticRenderFns } from "./PainelLoteTabela.vue?vue&type=template&id=636edd84&scoped=true"
import script from "./PainelLoteTabela.vue?vue&type=script&lang=js"
export * from "./PainelLoteTabela.vue?vue&type=script&lang=js"
import style0 from "./PainelLoteTabela.vue?vue&type=style&index=0&id=636edd84&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636edd84",
  null
  
)

export default component.exports